import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { TomosGrid } from './components/TomosGrid';
import { BonosSection } from './components/BonosSection';
import { PricingCards } from './components/PricingCards';
import { BlindajeComparison } from './components/BlindajeComparison';
import { TestimonialsBlock } from './components/TestimonialsBlock';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostoOportunidad } from './components/CostoOportunidad';
import { StackValue } from './components/StackValue';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { SaleNotifications } from './components/SaleNotifications';
export function App() {
  return <div className="min-h-screen bg-brand-dark flex flex-col relative w-full overflow-x-hidden" data-id="element-0">
      <TopBar data-id="element-1" />

      <main className="flex-1" data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TomosGrid data-id="element-6" />
        <BonosSection data-id="element-7" />

        {/* First Pricing Section */}
        <PricingCards data-id="element-8" />

        <BlindajeComparison data-id="element-9" />
        <TestimonialsBlock data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <CostoOportunidad data-id="element-13" />

        {/* Final CTA Section - Reusing PricingCards */}
        <div className="pt-12 md:pt-20 bg-brand-light" data-id="element-14">
          <div className="text-center mb-8 px-4" data-id="element-15">
            <h2 className="text-3xl font-black text-white uppercase" data-id="element-16">
              No dejes pasar esta oportunidad
            </h2>
          </div>
          <PricingCards data-id="element-17" />
        </div>

        <StackValue data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
      <StickyCTA data-id="element-20" />
      <SaleNotifications data-id="element-21" />
    </div>;
}